// extracted by mini-css-extract-plugin
export default {"modal-header":"MapTypeInfo--modal-header--advB4","modalHeader":"MapTypeInfo--modal-header--advB4"};